import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { WalletProvider } from '../../providers/wallet/wallet';
import { NumberFormatter } from '../../pipes/currency-pipe';
import { CommonProvider } from '../../providers/common/common';
@Component({
  selector: 'rmt-wallet-balance-and-qr',
  templateUrl: 'rmt-wallet-balance-and-qr.html'
})
export class RmtWalletBalanceAndQrComponent {
  @Input() balance:string;
  @Input() currency:string;
  @Input() isLoading:boolean = true;
  @Input() qrCodeImgString:string = "";
  @Input() canShowQRCode:boolean = true;
  @Input() canClickQR:boolean = true;
  @Output() qrClickEmitter: EventEmitter<any> = new EventEmitter();
  @Output() showOrHideBalanceEmitter: EventEmitter<any> = new EventEmitter();
  @Output() walletDetailsInfo: EventEmitter<any> = new EventEmitter();
  isShowWalletBalance: boolean = true;
  walletBalanceDots:string = "";
  isSN: boolean = false;
  isBalanceMillion: boolean = false;
  private static readonly MIN_BALANCE_FONT_PX = 20;
  private static readonly BALANCE_FONT_STEP_PX = 2;

  constructor(private walletProvider: WalletProvider, private currencyFormatter: NumberFormatter, private commonProvider: CommonProvider, private elementRef: ElementRef) {
    this.isSN = this.commonProvider.isSN();
  }

  toggleBalanceShow(){
    this.isShowWalletBalance = !this.isShowWalletBalance;
    this.walletProvider.isShowWalletBalance = this.isShowWalletBalance;
    if(this.showOrHideBalanceEmitter){
      this.showOrHideBalanceEmitter.emit(this.isShowWalletBalance)
    }
    this.fitBalanceToWidth();
  }

  ngAfterViewInit() {
    this.isShowWalletBalance = this.walletProvider.isShowWalletBalance;
    this.fitBalanceToWidth();
  }

  ngOnChanges(changes: any) {
    if(changes && changes.balance && changes.balance.currentValue !== changes.balance.previousValue){
      if(changes.balance.currentValue)
        this.balance = (changes.balance.currentValue == '0') ? '0' : (this.currencyFormatter.transform(changes.balance.currentValue, this.currency) || `${changes.balance.currentValue}`);
      this.setBalanceHideInfo();
    }
    // balance, currency or isLoading changed: the row is (re)rendered, so re-measure it
    this.fitBalanceToWidth();
  }

  /**
   * OM-19112 — the amount column has a fixed width (the QR takes the rest), so a long
   * formatted balance like "2,353.32 MYR" overflowed and the currency wrapped onto its own
   * line. The row is now nowrap; this shrinks the amount font step by step until the row fits.
   * Runs after the next render so the measured row is the one currently displayed.
   */
  private fitBalanceToWidth() {
    setTimeout(() => {
      const row: HTMLElement = this.elementRef.nativeElement.querySelector('.balance-row');
      if (!row || !row.parentElement) return;
      row.style.fontSize = '';
      const available = row.parentElement.clientWidth;
      if (!available) return;
      let size = parseFloat(window.getComputedStyle(row).fontSize);
      while (row.scrollWidth > available && size - RmtWalletBalanceAndQrComponent.BALANCE_FONT_STEP_PX >= RmtWalletBalanceAndQrComponent.MIN_BALANCE_FONT_PX) {
        size -= RmtWalletBalanceAndQrComponent.BALANCE_FONT_STEP_PX;
        row.style.fontSize = `${size}px`;
      }
    });
  }

  setBalanceHideInfo(){
    if(this.balance && this.balance.toString().length>0){
      // Only SN wallets can hold 7 figure balance at the moment which is causing the QR to wrap onto the next line on smaller screens like Z Fold
      //Check other country wallet if hold 6 figure balance with decimal digit.
      const balanceStr = this.balance.toString();
      if (balanceStr.includes('.')) {
        const [intPart, decPart] = balanceStr.split('.');
        const balanceAsInt = parseInt(intPart + decPart);
        this.isBalanceMillion = balanceAsInt >= 100000;
      } else {
        this.isBalanceMillion = parseInt(balanceStr) >= 1000000;
      }
      this.walletBalanceDots = Array(7).join("•");
    }
  }

  onQRCodeClick(){
    if(this.qrClickEmitter && this.canClickQR === true){
      this.qrClickEmitter.emit(this.isShowWalletBalance);
    }
  }

  onClickWalletBalanceInfo() {
    this.walletDetailsInfo.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-wallet-balance-and-qr/rmt-wallet-balance-and-qr.ts